import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, apiUrl } from '../config/api';

const Saci = ({ currentUser, currentUserRole }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ cod: '', denumire: '', furnizor: '' });

  const isOperator = (currentUserRole === 'Operatori' || currentUserRole === 'Operator');
  const isAdmin = (currentUserRole === 'Admin' || currentUserRole === 'Administrator');

  useEffect(()=>{ fetchAll(); },[]);

  const fetchAll = async () => {
    try { const res = await axios.get(`${API_BASE_URL}/saci`); setRows(res.data); } catch(e){ console.error(e); setError('Eroare la încărcarea sacilor'); }
  };

  const openAdd = () => { if(isOperator){ setError('Operatorii nu pot adăuga saci'); return;} setEditing(null); setForm({ cod:'', denumire:'', furnizor:''}); setShowModal(true); };
  const openEdit = (r) => { if(isOperator){ setError('Operatorii nu pot edita'); return;} setEditing(r); setForm({ cod:r.cod, denumire:r.denumire, furnizor:r.furnizor||''}); setShowModal(true); };

  const save = async () => {
    if(isOperator){ setError('Operatorii nu pot salva'); return; }
    if(!form.cod.trim() || !form.denumire.trim()){ setError('Cod și denumire obligatorii'); return; }
    try {
      setLoading(true);
      if(editing){
        await axios.put(`${API_BASE_URL}/saci/${editing.id}`, { ...form, currentUser: currentUser?.username });
      } else {
        await axios.post(`${API_BASE_URL}/saci`, { ...form, createdBy: currentUser?.username });
      }
      setShowModal(false); setEditing(null); setForm({ cod:'', denumire:'', furnizor:''}); await fetchAll();
      setError(editing ? 'Sac actualizat!' : 'Sac adăugat!'); setTimeout(()=>setError(''),3000);
    } catch(e){ console.error(e); setError(e.response?.data?.error || 'Eroare la salvare'); } finally { setLoading(false); }
  };

  const remove = async (r) => {
    if(isOperator){ setError('Operatorii nu pot șterge'); return; }
    if(!window.confirm(`Șterge sacul \"${r.cod} - ${r.denumire}\"?`)) return;
    try { setLoading(true); await axios.delete(`${API_BASE_URL}/saci/${r.id}`, { data:{ currentUser: currentUser?.username }}); await fetchAll(); setError('Sac șters'); setTimeout(()=>setError(''),3000);} catch(e){ console.error(e); setError(e.response?.data?.error || 'Eroare la ștergere'); } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="card">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem' }}>
          <h3 style={{ margin:0 }}>🎒 Saci</h3>
          <div style={{ display:'flex', gap:'0.5rem' }}>
            {!isOperator && (
              <>
                <button className="btn btn-primary" onClick={openAdd} disabled={loading}>➕ Adaugă Sac</button>
                <button className="btn btn-secondary" onClick={fetchAll} disabled={loading}>🔄 Reîncarcă</button>
              </>
            )}
          </div>
        </div>
        {error && (
          <div style={{ background: error.match(/adăugat|șters|actualizat/i) ? '#d4edda':'#f8d7da', color: error.match(/adăugat|șters|actualizat/i) ? '#155724':'#721c24', padding:'0.6rem 0.75rem', border:'1px solid #ccc', borderRadius:6, marginBottom:'0.75rem' }}>{error}</div>
        )}
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#f8f9fa' }}>
                <th style={{ padding:'0.5rem', textAlign:'left', borderBottom:'1px solid #dee2e6' }}>Cod</th>
                <th style={{ padding:'0.5rem', textAlign:'left', borderBottom:'1px solid #dee2e6' }}>Denumire</th>
                <th style={{ padding:'0.5rem', textAlign:'left', borderBottom:'1px solid #dee2e6' }}>Furnizor</th>
                <th style={{ padding:'0.5rem', textAlign:'left', borderBottom:'1px solid #dee2e6' }}>Creat de</th>
                <th style={{ padding:'0.5rem', textAlign:'center', borderBottom:'1px solid #dee2e6' }}>Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id} style={{ borderBottom:'1px solid #eee' }}>
                  <td style={{ padding:'0.5rem' }}>{r.cod}</td>
                  <td style={{ padding:'0.5rem' }}>{r.denumire}</td>
                  <td style={{ padding:'0.5rem' }}>{r.furnizor || ''}</td>
                  <td style={{ padding:'0.5rem' }}>{r.createdBy}</td>
                  <td style={{ padding:'0.5rem', textAlign:'center' }}>
                    <div style={{ display:'flex', gap:'0.5rem', justifyContent:'center' }}>
                      <button className="btn btn-warning" onClick={()=>openEdit(r)} disabled={isOperator} style={{ padding:'0.25rem 0.5rem' }}>✏️ Editează</button>
                      <button className="btn btn-danger" onClick={()=>remove(r)} disabled={isOperator} style={{ padding:'0.25rem 0.5rem' }}>🗑️ Șterge</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', justifyContent:'center', alignItems:'center', zIndex:1000, padding:'1rem' }}>
          <div style={{ background:'#fff', padding:'1.75rem 2rem', borderRadius:14, width:'100%', maxWidth:520, boxShadow:'0 10px 32px rgba(0,0,0,0.28)', display:'flex', flexDirection:'column', animation:'fadeInScale 0.18s ease-out' }}>
            <h3 style={{ margin:'0 0 1.4rem', textAlign:'center' }}>{editing ? '✏️ Editează Sac' : '➕ Adaugă Sac'}</h3>
            <div style={{ display:'flex', flexDirection:'column', gap:'1rem', alignItems:'center' }}>
              <div style={{ width:'100%', maxWidth:400 }}>
                <label style={{ display:'block', marginBottom:6, fontWeight:500, textAlign:'center' }}>Cod</label>
                <input type="text" value={form.cod} onChange={e=>setForm({ ...form, cod:e.target.value })} style={{ width:'100%', padding:'0.65rem 0.75rem', border:'1px solid #ced4da', borderRadius:8, textAlign:'center' }} />
              </div>
              <div style={{ width:'100%', maxWidth:400 }}>
                <label style={{ display:'block', marginBottom:6, fontWeight:500, textAlign:'center' }}>Denumire</label>
                <input type="text" value={form.denumire} onChange={e=>setForm({ ...form, denumire:e.target.value })} style={{ width:'100%', padding:'0.65rem 0.75rem', border:'1px solid #ced4da', borderRadius:8, textAlign:'center' }} />
              </div>
              <div style={{ width:'100%', maxWidth:400 }}>
                <label style={{ display:'block', marginBottom:6, fontWeight:500, textAlign:'center' }}>Furnizor</label>
                <input type="text" value={form.furnizor} onChange={e=>setForm({ ...form, furnizor:e.target.value })} placeholder="(optional)" style={{ width:'100%', padding:'0.65rem 0.75rem', border:'1px solid #ced4da', borderRadius:8, textAlign:'center' }} />
              </div>
              <div style={{ display:'flex', gap:'0.9rem', justifyContent:'center', marginTop:'0.75rem' }}>
                <button className="btn btn-secondary" onClick={()=>{ setShowModal(false); setEditing(null); }} disabled={loading} style={{ minWidth:130 }}>Anulează</button>
                <button className="btn btn-primary" onClick={save} disabled={loading} style={{ minWidth:150 }}>{loading ? 'Se salvează...' : 'Salvează'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Saci;
